import React from 'react'
import { Link, useLocation } from "react-router-dom";
import { Navbar, Nav, Container } from "react-bootstrap";
export const MyNavbar = () => {
  const location = useLocation();
    const currentPath = location.pathname;
  return (
    <Navbar expand="lg" fixed="top">
      <Container fluid>
        {/* Logo */}
        <Navbar.Brand as={Link} to="/">
          <img 
            src="KashyapbioLogo-1.webp" 
            alt="Logo" 
            width="430"
            height="80" 
          />
        </Navbar.Brand>

        {/* Navbar Toggle for Mobile */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/" className={currentPath === "/" ? "active-nav" : ""}>Home</Nav.Link>
            <Nav.Link as={Link} to="/about" className={currentPath === "/about" ? "active-nav" : ""}>About Us</Nav.Link>
            <Nav.Link as={Link} to="/product" className={currentPath === "/product" ? "active-nav" : ""}>Products</Nav.Link>
            <Nav.Link as={Link} to="/process" className={currentPath === "/process" ? "active-nav" : ""}>Process</Nav.Link>
            <Nav.Link as={Link} to="/applications" className={currentPath === "/applications" ? "active-nav" : ""}>Application</Nav.Link>
            <Nav.Link as={Link} to="/contact" className={currentPath === "/contact" ? "active-nav" : ""}>Contact Us</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
